// extracted by mini-css-extract-plugin
module.exports = {"today":"_2EGFs","mobile":"_1l_kM","full":"_199Ae","rounded":"_2TGu_"};